import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessJoinFormComponent } from './bussiness-join-form/business-join-form.component';
import { BizRoutingModule } from './business-routing.module';
import { ShareModule } from '../shareModule/shareModule';



@NgModule({
  declarations: [BusinessJoinFormComponent],
  imports: [
    CommonModule,
   // BizRoutingModule,
    ShareModule
  ]
})
export class BusinessModule { }
